import Section from "./Section";
import Row from "./Row";
import { motion } from "framer-motion";

// ✅ your animations
import { fadeUp, fadeIn, slideLeft, slideRight } from "animations/variants";

const Billing = ({ order }) => {
  const safe = (val, fallback = "-") => val || fallback;

  return (
    <motion.div variants={slideLeft}>
      <Section title="Billing Information">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <p className="font-medium mb-2"></p>
            <p>{safe(order?.customer_info?.firstname)}</p>
            <p>{safe(order?.customer_info?.phoneNumber)}</p>
            <p>{safe(order?.customer_info?.email)}</p>
          </div>

          <div>
            <Row
              label="Payment Method"
              value={safe(order?.payments?.paymentMethod)}
            />
            <Row label="Amount" value={`$${safe(order?.totalPrice)}`} />
          </div>
        </div>
      </Section>
    </motion.div>
  );
};

export default Billing;
